require([
    'jquery',
    'base/MbiHelper',
    'base/MbiImageSize',
    'base/MbiMediaQuery',
    // 'project/Vendor/nouislider.min',
    'project/Validate',

    'base/Vendor/PictureFill',
    'base/MbiBackgroundImage',
    'base/MbiBrowser',
    'base/MbiLazySizes',
    // 'project/Vendor/HoverHandler',
    'wow',
    // 'project/Ajax',
    'project/Templates',
    // 'project/Vendor/debounce',
    // 'number'
], function(
    $,
    _,
    mbiImageSize,
    mbiMq,
    // noUiSlider,
    // GMaps,
    V
    ) {

    'use strict';

// console.log('what is going on');
//remove when live - for search query only.
var $urlPrefix = '';
// mbiMq.init();
if('lap-' in mbiMq.mqArea || $('html').hasClass('touch') || $('html').hasClass('ie10')) {
    // $('.js_ajax').removeClass('js_ajax');
    // console.log('ie?');
} else {
    var wow = new WOW({
        offset: 130,
        mobile: false
    }).init();
    // console.log('no ie');
}

$(document).on('click', '.logo', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    },1200);
});
// SUCHE MIT CLICK AUF js_search

$(document).on('click', '.js_gototop', function(){
    $('html, body').animate({
        scrollTop: 0
    },1000)

    // var form = $('#search').serializeArray();
});





function createnav() {
    var menu = $(document).find('[data-menu]');
    var menuString = '';
    menu.each(function(index, el) {

        var name = $(this).attr('data-menu');
        if(name != '') {
            var $class = '';
            menuString += '<div class="menu-entry js_scrollto" data-target="'+name+'">'+name+'</div>';
        }
    });
    $('#topnav .menu-wrapper').prepend(menuString);
}
createnav();

$(document).on('click', '.js_scrollto', function(){
    $('.menu-entry').removeClass('is_active');
    var target = $(document).find('[data-menu="'+$(this).attr('data-target')+'"]').offset().top;
    $('body, html').animate({
        scrollTop: target
    }, 600);
    $(this).addClass('is_active');

    $('.menu-wrapper').removeClass('is_active');
    $('.menu-burger').removeClass('is_hidden');
    $('body').removeClass('menu-open');
    $('.menu-burger.xerl').addClass('is_hidden');
});


$(document).on('click', '.js_next', function(){
    var target = $('[data-menu="'+$(this).attr('data-next')+'"]').offset().top - 50;
    $('body, html').animate({
        scrollTop: target
    }, 600);
});

$(document).on('click','.js_send-request', function(){
    // console.log('clicked anfrage');
    // console.log($('.forminfos').attr('data-title'));
    if($('#anfrageform').valid() == true ){
        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'sendmail',
                form: $('#anfrageform').serializeArray(),
                title: $('.forminfos').attr('data-title')
            },
        })
        .done(function() {
            $('input, textarea').val('');
            $('#anfrageform').addClass('is_hidden');
            window.location = location + "#danke";
            $('#anfrageform').addClass('inactive');
            $('.danke').addClass('active');
            $('.button-send').addClass('inactive');
            $('.headline-anfrage').addClass('inactive');
            if('paw-' in mbiMq.mqArea) {
                $('html, body').animate({
                    scrollTop: 0
                }, 100);
            }
        })
        .fail(function() {
            // console.log("error");
        })
        .always(function() {
            // console.log("complete");
        });
    }

    setTimeout(function() {
        $('.input-field').removeClass('error');
    }, 3000);

});

$(document).on('mouseenter', '.js_stockwerk', function(){
    $('.rendering').addClass($(this).attr('data-haus')+'_is_active_hover');
    $('.stock-rendering .nr').html($(this).attr('data-nr') + '');
    $('.stock-rendering .et').html('Haus ');
});

$(document).on('mouseleave', '.js_stockwerk', function(){
    $('.rendering').removeClass($(this).attr('data-haus')+'_is_active_hover');
    $('.stock-rendering .nr').html('');
    $('.stock-rendering .et').html('');
});

$(document).on('mouseenter', '.js_vorsorge', function(){
    $('.rendering').addClass($(this).attr('data-haus')+'_is_active_hover');
    $('.stock-rendering .nr').html($(this).attr('data-nr') + '');
    $('.stock-rendering .et').html('Haus ');
});

$(document).on('mouseleave', '.js_vorsorge', function(){
    $('.rendering').removeClass($(this).attr('data-haus')+'_is_active_hover');
    $('.stock-rendering .nr').html('');
    $('.stock-rendering .et').html('');
});

$(document).on('click touch', '.js_open-menu', function(){
    // console.log('open click');
    $('.menu-wrapper').addClass('is_active');
    $('.menu-burger').removeClass('is_hidden');

    $('body').addClass('menu-open');
    $(this).addClass('is_hidden');
});

$(document).on('click touch', '.js_close-menu', function(){
    $('.menu-wrapper').removeClass('is_active');
    $('.menu-burger').removeClass('is_hidden');
    $('body').removeClass('menu-open');
    $(this).addClass('is_hidden');
});


$(document).on('click', '.js_open-impressum', function(){
    $('.impressum-wrapper').addClass('is_active');
    $('body').addClass('is_impressum-open');
});

$(document).on('click', '.js_close-impressum', function(){
    $('.impressum-wrapper').removeClass('is_active');
    $('body').removeClass('is_impressum-open');
});


$(document).on('mouseenter', '.js_open-stock', function() {
    var target = $(this).attr('data-etage-link');
    $('.stock-nav').removeClass('is_hover');
    $('.stock-nav[data-etage-link="'+target+'"]').addClass('is_hover');
    $('.rendering-wrapper').removeClass('hover-0 hover-1 hover-2 hover-3 hover-4 hover-5');
    $('.rendering-wrapper').addClass('hover-'+target);
});

$(document).on('mouseout', '.js_open-stock', function() {
    $('.stock-nav').removeClass('is_hover');
    $('.rendering-wrapper').removeClass('hover-0 hover-1 hover-2 hover-3 hover-4 hover-5');
});

$(document).on('click', '.js_open-stock', function(){

    $('.stock').removeClass('is_active');
    $(this).addClass('is_active');

    var target = $(this).attr('data-etage-link');
    $('.wohnung-navigation-bottom').addClass('is_active');

    $('.stock-nav').removeClass('is_active');
    $('.stock-nav[data-etage-link="'+target+'"]').addClass('is_active');

    $('.rendering-wrapper').removeClass('active-0 active-1 active-2 active-3 active-4 active-5');
    $('.rendering-wrapper').addClass('active-'+target);
    $('.section-wohnung').find('.swiper').removeClass('is_active').addClass('is_hidden');
    var sw = $('.swiper[data-etage='+target+']').attr('id');
    var flkty = $(document).find('.swiper[data-etage='+target+']');
    var t = '#' + sw;

    $(document).find('[data-buttons]').removeClass('is_active');
    $(document).find('[data-buttons="'+sw+'"]').addClass('is_active').find('.button').first().addClass('is_active');

    $(document).find('.swiper[data-etage='+target+']').addClass('is_active').removeClass('is_hidden');
    $.flickityObjects[t].resize();
    var scrolltarget = flkty.offset().top - 140;

    if('lap-' in mbiMq.mqArea) {
        scrolltarget = flkty.offset().top - 270;
    }
    $('html, body').animate({
        scrollTop: scrolltarget
    }, 500)
});

});


define("Assets/Js/Footer.js", function(){});

